module.exports = __webpack_public_path__ + "img/11_sustainable_cities_and_communities_color.e9457f21.svg";